import * as React from 'react';
import { cn } from '@/lib/utils';
import * as Icons from 'lucide-react';

export function LiveStatusStrip({ metrics = [], className }) {
  return (
    <div className={cn('flex items-center gap-6 text-sm', className)}>
      <div className="flex items-center gap-2">
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-primary"></span>
        </span>
        <span className="font-medium">Live</span>
      </div>
      {metrics.map((metric, idx) => (
        <div key={idx} className="flex items-center gap-2">
          <span className="text-muted-foreground">{metric.label}:</span>
          <span className={cn('font-semibold data-text', metric.className)}>
            {metric.value}
          </span>
        </div>
      ))}
    </div>
  );
}